import { render } from "./DetalleInspeccionHomeComponent.vue?vue&type=template&id=67868d42"
import script from "./DetalleInspeccionHomeComponent.vue?vue&type=script&lang=js"
export * from "./DetalleInspeccionHomeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__